import { svgToIcon } from '../../../aha-editor-v2/src/components/Toolbar/toolbarUtils';
import { isShapeSmartRecord } from '../objects/guards';
import Tool, { simpleToolButton, type IToolAvailableInput } from './Tool';
import convertAhaShapesIcon from '../assets/icons/convertAhaShapesIcon.svg';

class ToolCreateSmartRecords extends Tool {
  static toolName = 'Convert to Aha! records';

  static action({ controller }) {
    controller.actionSetSmartRecordItems();
  }

  static available({ selection }: IToolAvailableInput): boolean {
    const objects = selection?.getObjects();
    return !!objects?.every(obj => isShapeSmartRecord(obj));
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolCreateSmartRecords,
      svgToIcon(convertAhaShapesIcon)
    );
  }
}

export default ToolCreateSmartRecords;
